import InfoIcon from '@mui/icons-material/Info';

import { FooterText } from '../footer-text/FooterText';

const YouCanComeBackNote: React.FC = () => {
  return (
    <FooterText
      icon={<InfoIcon fontSize="small" />}
      text="You can always come back and resume by logging in with your
      email/phone number"
    />
  );
};

export { YouCanComeBackNote };
